import React from 'react';

import { Typography, Tooltip, CSSObject } from '@mui/material';

import { channelIcons } from 'domains/campaigns/pages/CurationsPage/utils';
import { CampaignChannels } from 'domains/campaigns/types';

export type Props = {
    contentType?: CampaignChannels;
    isActive: boolean;
    onClick: () => void;
};

const labelStyles: CSSObject = {
    color: '#ffffff',
    fontSize: '1rem',
    position: 'relative',
    top: '-0.094rem',
};

const previewButtonStyles: React.CSSProperties = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
};

const ButtonContentPreview = ({ contentType = CampaignChannels.EMAIL, isActive, onClick }: Props) => {
    const iconStyles = {
        color: isActive ? 'secondary.main' : 'primary.main',
        '&:hover': {
            color: 'secondary.main',
        },
    };

    const ContentIcon = channelIcons[contentType];

    return (
        <Tooltip
            title={
                <Typography variant="body1" sx={labelStyles}>
                    Preview content
                </Typography>
            }
            placement="top"
        >
            <button onClick={onClick} aria-label="Preview content" style={previewButtonStyles}>
                <ContentIcon aria-hidden sx={iconStyles} />
            </button>
        </Tooltip>
    );
};

export default ButtonContentPreview;
